// extracted by mini-css-extract-plugin
module.exports = {"collapsedText":"ExpandableText_collapsedText__3_J_f","expandButton":"ExpandableText_expandButton__2phEK"};